
<template>
      <Form inline >
            <FormItem :label="$t('global.common.project',{defaultValue:'项目'})" :label-width="60">
                <Select clearable v-model="formData['EQ_stockVirtualGroupEntity.lineId']" filterable >
                    <!-- <Option value= ''>All</Option>
                    <Option value="-1">Others</Option> -->
                    <Option v-for="item in getNewProductList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
            </FormItem>
            <FormItem label='ERP SKU' :label-width="70">
                <Input clearable v-model="formData['EQ_stockVirtualGroupEntity.erpSku']"/>
            </FormItem>
            <FormItem :label="$t('erp.virtualstore.groupname',{defaultValue:'虚拟仓分组'})" :label-width="110">
                <Input clearable v-model="formData.CN_name"/>
            </FormItem>
            <FormItem :label-width="1">
                <Button type="primary" @click="update" icon="ios-search">{{$t('global.common.search',{defaultValue:'搜索'})}}</Button>
                <Button class="margin-left-10" @click="reset" icon='md-refresh'>{{$t('global.common.btn_reset',{defaultValue:'重置'})}}</Button>
            </FormItem>
        </Form>
</template>
<script>
import { mapState,mapGetters } from 'vuex';
export default {
    data() {
        return {
            formData: {
                "EQ_stockVirtualGroupEntity.erpSku": '',
                "EQ_stockVirtualGroupEntity.lineId": '',
                CN_name: '',
                EQ_disabledAt: 0,
            },
        };
    },
    mounted() {
        this.update();


    },
    computed: {
        ...mapGetters('diction',['getNewProductList']),
    },
    methods: {
        update() {
            this.$emit('on-update', { search: this.formData });
        },
        reset() {
            this.formData = {
                "EQ_stockVirtualGroupEntity.erpSku": '',
                "EQ_stockVirtualGroupEntity.lineId": '',
                CN_name: '',
                EQ_disabledAt: 0,
            };
            this.$emit('on-update', {
                search: this.formData,
                page: 1
            });
        },
    },
};
</script>
